export const floorsAdditionalSpinnerId = 'floorsAdditionalSpinnerId';
